<div class="container wrapper-content">
    <h1 class="tc">Frequently Asked Questions</h1>
    <div class="loading-container" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Loading content...</p>
    </div>
    <div class="faq-content" *ngIf="!isLoading && result && result.length > 0">
        <mat-accordion>
            <mat-expansion-panel 
                (opened)="panelOpenState = true" 
                (closed)="panelOpenState = false" 
                *ngFor="let item of result; let i = index" 
                [expanded]="i == 0"
                class="faq-panel">
                <mat-expansion-panel-header class="faq-header">
                    <mat-panel-title class="faq-question" [innerHTML]="item?.question || '---'">
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="faq-answer" [innerHTML]="item?.answer || '---'"></div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div class="no-content" *ngIf="!isLoading && (!result || result.length === 0)">
        <p>No FAQs available at the moment.</p>
    </div>
</div>